import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|ITS Score Reports|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.VmwareItsScoreReports,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryItsScoreReports';
export type SPCandidateHistoryItsScoreReportsLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelCode`
	| `${LocNameStart}LabelRegistrationNumber`
	| `${LocNameStart}LabelGrade`
	| `${LocNameStart}LabelDate`
	| `${LocNameStart}LabelExpires`
	| `${LocNameStart}LabelScoreReports`;

export const spCandidateHistoryItsScoreReportsLocs: LocDefs<SPCandidateHistoryItsScoreReportsLocNames> =
	{
		SPCandidateHistoryItsScoreReportsTitleTab: {
			defaultValue: 'ITS Score Reports',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.Title.Tab',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsTitlePage: {
			defaultValue: 'ITS Score Reports',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.Title.PageSectionTitle',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelCode: {
			defaultValue: 'Code',
			description: 'Column heading for: Code.',
			displayPath: `${pathStart}Code`,
			displayType: 'Label',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.ExternalId',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelRegistrationNumber: {
			defaultValue: 'Registration Number',
			description: 'Column heading for: Registration Number.',
			displayPath: `${pathStart}Registration Number`,
			displayType: 'Label',
			legacyName:
				'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.Registration',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelGrade: {
			defaultValue: 'Grade',
			description: 'Column heading for: Grade.',
			displayPath: `${pathStart}Grade`,
			displayType: 'Label',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.Grade',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelDate: {
			defaultValue: 'Date',
			description: 'Column heading for: Date.',
			displayPath: `${pathStart}Date`,
			displayType: 'Label',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.Date',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelExpires: {
			defaultValue: 'Expires',
			description: 'Column heading for: Expires.',
			displayPath: `${pathStart}Expires`,
			displayType: 'Label',
			legacyName: 'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.ExpireDate',
			...sharedProperties,
		},
		SPCandidateHistoryItsScoreReportsLabelScoreReports: {
			defaultValue: 'Score Reports',
			description: 'Column heading for: Score Reports.',
			displayPath: `${pathStart}Score Reports`,
			displayType: 'Label',
			legacyName:
				'VmwareItsScoreReports/Candidates.ItsScoreReports.ColumnHeading.ScoreReport',
			...sharedProperties,
		},
	};

export type SPCandidateHistoryItsScoreReportsLocType =
	LocMap<SPCandidateHistoryItsScoreReportsLocNames>;
